import React, { useState } from 'react';
import { MailIcon, PhoneIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Select } from '../components/ui/Select';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../lib/i18n';
import { trackPixel } from '../lib/pixel';
const WEB3FORMS_ACCESS_KEY = 'b7789131-e060-4196-aa41-6a4c61a3a4d1';
const WEB3FORMS_ACTION = 'https://api.web3forms.com/submit';
export function ContactPage() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitError(null);
    const formData = new FormData(e.currentTarget);
    const payload: Record<string, string> = {
      access_key: WEB3FORMS_ACCESS_KEY,
      subject: 'Kontakt upit - D-TECH Solutions',
      from_name: 'D-TECH sajt - kontakt',
      botcheck: ''
    };
    formData.forEach((value, key) => {
      if (typeof value === 'string') payload[key] = value;
    });
    setIsSubmitting(true);
    try {
      const response = await fetch(WEB3FORMS_ACTION, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (response.ok && result.success) {
        setIsSubmitting(false);
        setSubmitSuccess(true);
        if (typeof (window as any).gtag === 'function') {
          ;
          (window as any).gtag('event', 'generate_lead', {
            currency: 'EUR',
            value: 0,
            lead_source: 'contact_form'
          });
        }
        trackPixel('Lead', {
          content_name: 'Kontakt forma'
        });
      } else {
        setIsSubmitting(false);
        setSubmitError(en ? 'Sending failed. Please try again or contact us directly.' : ru ? 'Отправка не удалась. Пожалуйста, попробуйте еще раз или свяжитесь с нами напрямую.' : 'Slanje nije uspelo. Pokušajte ponovo ili nas kontaktirajte direktno.');
      }
    } catch (err) {
      setIsSubmitting(false);
      setSubmitError(en ? 'Network error. Please try again or contact us directly.' : ru ? 'Ошибка сети. Пожалуйста, попробуйте еще раз или свяжитесь с нами напрямую.' : 'Greška u mreži. Pokušajte ponovo ili nas kontaktirajte direktno.');
    }
  };
  return <main className="min-h-screen bg-dark-bg" data-id="element-710" data-mp="cd6e9qwaegdi">
      <section className="py-20 bg-dark-surface border-b-2 border-dark-border" data-id="element-711" data-mp="h4oegcqhkcxf">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-712" data-mp="h6sutu5kn4el">
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6" data-id="element-713" data-mp="21tipuv13li3c">
            <span className="text-brand-yellow" data-id="element-714" data-mp="1wuz3itile4ag">
              {en ? 'Contact' : ru ? 'Свяжитесь с' : 'Kontaktirajte'}
            </span>{' '}
            {en ? 'us' : ru ? 'нами' : 'nas'}
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-715" data-mp="26mv3yb85i6hu">
            {en ? 'Get in touch with our team for product inquiries, technical support or partnership opportunities.' : ru ? 'Свяжитесь с нашей командой для запросов о продукции, технической поддержки или возможностей партнерства.' : 'Stupite u kontakt sa našim timom za upite o proizvodima, tehničku podršku ili mogućnosti partnerstva.'}
          </p>
        </div>
      </section>

      <section className="py-20" data-id="element-716" data-mp="34897n0s6g3jz">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-717" data-mp="34boly1e118kc">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-718" data-mp="2z9plaz9o8pr3">
            <div data-id="element-719" data-mp="18tx1svf8k4yx">
              <h2 className="text-3xl font-black text-white mb-6" data-id="element-720" data-mp="18uf70hjvltiz">
                {en ? 'Have a question?' : ru ? 'Есть вопрос?' : 'Imate pitanje?'}
              </h2>
              {submitSuccess ? <Card data-id="element-721" data-mp="1mtoe8rq3tdat">
                  <div className="text-center py-8" data-id="element-722" data-mp="1mty3ue78lifz">
                    <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-723" data-mp="1rs9cillspmwm">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-724" data-mp="1wqt3x1j5rqwd">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-725" data-mp="25j4qudf2cw7l" />
                      </svg>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2" data-id="element-726" data-mp="2pmk2hos7megz">
                      {en ? 'Message sent!' : ru ? 'Сообщение отправлено!' : 'Poruka poslata!'}
                    </h3>
                    <p className="text-gray-300" data-id="element-727" data-mp="2bn15ns4umpjz">
                      {en ? 'Thank you for contacting us. We will get back to you shortly.' : ru ? 'Спасибо, что связались с нами. Мы ответим вам в ближайшее время.' : 'Hvala vam što ste nas kontaktirali. Uskoro ćemo vam se javiti.'}
                    </p>
                  </div>
                </Card> : <Card data-id="element-728" data-mp="3r39shuu296am">
                  <form onSubmit={handleSubmit} className="space-y-6" noValidate data-id="element-729" data-mp="3r3ru76zhscpx">
                    <Input label={en ? 'Full name *' : ru ? 'Полное имя *' : 'Ime i prezime *'} type="text" name="Ime_i_prezime" required placeholder={en ? 'Your name' : ru ? 'Ваше имя' : 'Vaše ime i prezime'} data-id="element-730" data-mp="1keragjkrix7s" />
                    <Input label={en ? 'Email *' : 'Email *'} type="email" name="email" required placeholder={en ? 'your@email.com' : ru ? 'vas.email@primer.com' : 'vas.email@primer.com'} data-id="element-731" data-mp="rrdaeclrpljg" />
                    <Input label={en ? 'Phone *' : ru ? 'Телефон *' : 'Telefon *'} type="tel" name="Telefon" required placeholder={en ? '+1 ...' : ru ? '+7 ...' : '+381 60 123 4567'} data-id="element-732" data-mp="ahj5j4svwyfp" />
                    <Select label={en ? 'Inquiry type *' : ru ? 'Тип запроса *' : 'Tip upita *'} name="Tip_upita" required defaultValue="" options={[{
                  value: '',
                  label: en ? 'Select category...' : ru ? 'Выберите категорию...' : 'Izaberite kategoriju...',
                  disabled: true
                }, {
                  value: 'Elektricni transporter',
                  label: en ? 'Electric transporter' : ru ? 'Электрический транспортер' : 'Električni transporter'
                }, {
                  value: 'Servis',
                  label: en ? 'Service' : ru ? 'Сервис' : 'Servis'
                }, {
                  value: 'Opsti upit',
                  label: en ? 'General inquiry' : ru ? 'Общий запрос' : 'Opšti upit'
                }]} data-id="element-733" data-mp="u4h427up5d1t" />
                    <Textarea label={en ? 'Message *' : ru ? 'Сообщение *' : 'Poruka *'} name="Poruka" required placeholder={en ? 'Tell us about your needs or questions' : ru ? 'Расскажите нам о ваших потребностях или вопросах' : 'Recite nam o vašim potrebama ili pitanjima'} rows={6} data-id="element-734" data-mp="19v9o7onyp913" />
                    {submitError && <div className="p-4 bg-red-500/10 border-2 border-red-500/50 rounded-industrial text-sm text-red-300" data-id="element-735" data-mp="h7x3zl59xday">
                        {submitError}
                      </div>}
                    <Button type="submit" variant="primary" size="lg" disabled={isSubmitting} className="w-full" data-id="element-736" data-mp="2bi0lnpxt3its">
                      {isSubmitting ? en ? 'Sending...' : ru ? 'Отправка...' : 'Šaljem...' : en ? 'Send message' : ru ? 'Отправить сообщение' : 'Pošalji poruku'}
                    </Button>
                    <p className="text-sm text-brand-yellow text-center font-semibold" data-id="element-737" data-mp="iqiq97xuau32">
                      {en ? 'We respond to all inquiries within 24h.' : ru ? 'Мы отвечаем на все запросы в течение 24 часов.' : 'Odgovaramo na upit u roku od 24h.'}
                    </p>
                  </form>
                </Card>}
            </div>

            <div data-id="element-738" data-mp="3hsadz0i8932p">
              <h2 className="text-3xl font-black text-white mb-6" data-id="element-739" data-mp="3hstm5pi2sd3j">
                {en ? 'Contact information' : ru ? 'Контактная информация' : 'Kontakt informacije'}
              </h2>
              <div className="space-y-6" data-id="element-740" data-mp="3vsbeufyhsai6">
                <Card data-id="element-741" data-mp="3vp71arz502eu">
                  <div className="flex items-start space-x-4" data-id="element-742" data-mp="4kyyu49ci33u">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-743" data-mp="4k7a9de615n2">
                      <MailIcon className="w-6 h-6 text-dark-bg" data-id="element-744" data-mp="3qs6vmi6791o9" />
                    </div>
                    <div data-id="element-745" data-mp="3qu029xgtblw9">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-746" data-mp="2adfej1ei7gu9">
                        {ru ? 'Эл. почта' : 'Email'}
                      </h3>
                      <a href="mailto:info@dtech.rs" className="text-brand-yellow hover:text-brand-yellow-dark transition-colors text-lg" data-id="element-747" data-mp="2faxdq02pyhp2">
                        info@dtech.rs
                      </a>
                      <p className="text-sm text-gray-400 mt-2" data-id="element-748" data-mp="c36rpdi2gn3s">
                        {en ? 'For all questions, inquiries and support' : ru ? 'По всем вопросам, запросам и поддержке' : 'Za sva pitanja, upite i podršku'}
                      </p>
                    </div>
                  </div>
                </Card>
                <Card data-id="element-749" data-mp="3pd485rn8x6cf">
                  <div className="flex items-start space-x-4" data-id="element-750" data-mp="3kbx1xx0r4f7v">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-751" data-mp="3kdrjd1ctdp77">
                      <PhoneIcon className="w-6 h-6 text-dark-bg" data-id="element-752" data-mp="1ikk57v8xtdmw" />
                    </div>
                    <div data-id="element-753" data-mp="1q42weosc4d6k">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-754" data-mp="1q4mcdzyfcrhy">
                        {en ? 'Phone' : ru ? 'Телефон' : 'Telefon'}
                      </h3>
                      <a href="tel:+381653312811" className="text-brand-yellow hover:text-brand-yellow-dark transition-colors text-lg" data-id="element-755" data-mp="1v0tchc4538rz">
                        +381 65 331 2811
                      </a>
                      <p className="text-sm text-gray-400 mt-2" data-id="element-756" data-mp="1771q90n1o711">
                        {en ? 'Call us during working hours' : ru ? 'Звоните нам в рабочее время' : 'Pozovite nas u toku radnog vremena'}
                      </p>
                    </div>
                  </div>
                </Card>
                <Card data-id="element-757" data-mp="2sknzwb2ieusc">
                  <div className="flex items-start space-x-4" data-id="element-758" data-mp="2xhmqijmysjls">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-759" data-mp="2xftjv4ccpzds">
                      <ClockIcon className="w-6 h-6 text-dark-bg" data-id="element-760" data-mp="2r1e95rym6uyu" />
                    </div>
                    <div data-id="element-761" data-mp="2r3r0uwu6cjp3">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-762" data-mp="351p1z0jhijmn">
                        {en ? 'Working hours' : ru ? 'Часы работы' : 'Radno vreme'}
                      </h3>
                      <p className="text-gray-300 text-lg" data-id="element-763" data-mp="3a0icql7dzwj4">
                        {en ? <>
                            Monday - Friday
                            <br data-id="element-764" data-mp="3ntrogsit4u4t" />
                            10:00 - 17:00
                          </> : ru ? <>
                            Понедельник - Пятница
                            <br data-id="element-765" data-mp="3sqqb6q055ysz" />
                            10:00 - 17:00
                          </> : <>
                            Ponedeljak - Petak
                            <br data-id="element-766" data-mp="k9994b2ij22l" />
                            10:00 - 17:00
                          </>}
                      </p>
                      <p className="text-sm text-gray-400 mt-2" data-id="element-767" data-mp="68q4ldx9ae56">
                        {en ? 'We respond to all inquiries within 24 business hours' : ru ? 'Мы отвечаем на все запросы в течение 24 рабочих часов' : 'Odgovaramo na sve upite u roku od 24 radna sata'}
                      </p>
                    </div>
                  </div>
                </Card>
                <Card data-id="element-768" data-mp="3oo0kjsg8x79r">
                  <div className="flex items-start space-x-4" data-id="element-769" data-mp="3on7e6sl78js5">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-770" data-mp="39pf26aev2dip">
                      <MapPinIcon className="w-6 h-6 text-dark-bg" data-id="element-771" data-mp="3eo00g4ajyn4i" />
                    </div>
                    <div data-id="element-772" data-mp="2vlppg3b1oif4">
                      <div className="flex items-center gap-3 mb-2 flex-wrap" data-id="element-773" data-mp="2vlzk4471bdr5">
                        <h3 className="text-xl font-bold text-white" data-id="element-774" data-mp="2qs53xaqn1gwt">
                          {en ? 'Location' : ru ? 'Местоположение' : 'Lokacija'}
                        </h3>
                        <span className="inline-flex items-center rounded-full bg-brand-yellow/15 border border-brand-yellow/40 text-brand-yellow text-[11px] font-bold uppercase tracking-wider px-2.5 py-0.5" data-id="element-775" data-mp="2gwl6gjwfea5y">
                          {en ? 'Coming Soon' : ru ? 'Скоро' : 'Uskoro'}
                        </span>
                      </div>
                      <p className="text-gray-300 leading-relaxed" data-id="element-776" data-mp="34mnyj00cbg4k">
                        {en ? 'Our physical location is being prepared.' : ru ? 'Физическое местоположение в стадии подготовки.' : 'Fizička lokacija je u pripremi.'}
                      </p>
                      <p className="mt-2 text-brand-yellow italic font-semibold -skew-x-3 origin-left" data-id="element-777" data-mp="3q56gfmzzf9p">
                        {en ? 'We currently operate online.' : ru ? 'Сейчас мы работаем онлайн.' : 'Trenutno poslovanje vršimo online.'}
                      </p>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}